/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import DraftsIcon from '@material-ui/icons/Drafts';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import People from '@material-ui/icons/People';
import Business from '@material-ui/icons/Business';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import SendIcon from '@material-ui/icons/Send';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import ViewListIcon from '@material-ui/icons/ViewList';





class Sidebar2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClick = () => {

    this.setState({ open: !this.state.open });
  }

  handleClickOpen = (event, option) => {
    this.props.onChange(option);

  }

  render() {
    return (
      
      <div data-color="primary">
        <List
          style={{
            width: '100%',
            maxWidth: 350,
            minWidth: 300,
            height: 510
          }}
          color="primary"
          component="nav"
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader">
          Mis opciones
        </ListSubheader>
      }
    >
      {this.props.admin == true ?
      <>
       <ListItem button onClick={event => this.handleClickOpen(event,"users")}>
       <ListItemIcon>
         <People />
       </ListItemIcon>
       <ListItemText primary="Usuarios" />
     </ListItem>
     <ListItem button onClick={event => this.handleClickOpen(event,"emp")}>
       <ListItemIcon>
         <Business />
       </ListItemIcon>
       <ListItemText primary="Empresas"  />
     </ListItem>
     <ListItem button onClick={event => this.handleClickOpen(event,"ans")}>
       <ListItemIcon>
         <HelpOutlineIcon />
       </ListItemIcon>
       <ListItemText primary="Preguntas" />
     </ListItem>
     <ListItem button onClick={event => this.handleClickOpen(event,"products")}>
       <ListItemIcon>
         <ViewListIcon />
       </ListItemIcon>
       <ListItemText primary="Mis productos" />
     </ListItem>
     </>
      :
      null
      }
    <ListItem button onClick={event => this.handleClickOpen(event,"requeriments")}>
       <ListItemIcon>
         <Business />
       </ListItemIcon>
       <ListItemText primary="Mis solicitudes" />
     </ListItem>
      <ListItem button onClick={this.handleClick}>
        <ListItemIcon>
          < DraftsIcon/>
        </ListItemIcon>
        <ListItemText primary="Mensajes" />
        {this.state.open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={this.state.open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button onClick={event => this.handleClickOpen(event,"resivedmsj")}>
            <ListItemIcon>
              <CallReceivedIcon />
            </ListItemIcon>
            <ListItemText primary="Recibidos" />
          </ListItem>
        </List>
      </Collapse>
      <Collapse in={this.state.open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button onClick={event => this.handleClickOpen(event,"sendmsj")} >
            <ListItemIcon>
              <SendIcon />
            </ListItemIcon>
            <ListItemText primary="Enviados" />
          </ListItem>
        </List>
      </Collapse>
    </List>
      </div>
    );
  }
}

export default Sidebar2;